export enum PaymentFrequencySchedule {
  daily = 'Daily',
  weekly = 'Weekly',
  biweekly = 'Biweekly',
}
